// Google Tag Manager: sending data

$(function () {

  // carreer form
  const careerForm = document.getElementById('careerContactForm');
  if (careerForm) {
    careerForm.addEventListener('submit', function (event) {
      event.preventDefault();
      dataLayer.push({
        'event': 'ga.event',
        'eventData': {
          'category': 'Formular',
          'action': 'Kariera',
          'label': 'Odeslan',
          'value': 0
        }
      });
      careerForm.submit();
    });
  }

  // newsletter form
  const newsletterForm = document.getElementById('mc-embedded-subscribe-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();
      dataLayer.push({ 'event': 'ga.event', 'eventData': { 'category': 'Formular', 'action': 'Chci EUC Novinky', 'label': 'Odeslan', 'value': 0 } });
      newsletterForm.submit();
    });
  }

});
